import { useEffect } from "react";
import { App } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { getLimitError } from "redux/Datasets/selectors";
import { setLimitError } from "redux/Datasets/actions";

import MaxAmountDataset from "./MaxAmountDataset";

function LimitExceedModal() {
  const dispatch = useDispatch();
  const limitError = useSelector(getLimitError);
  const { modal } = App.useApp();

  useEffect(() => {
    if (!limitError) return;

    const instance = modal.warning({
      title: `Max amount of Datasets`,
      content: <MaxAmountDataset limitErrorMessage={limitError} />,
      width: 560,
      okText: "Close",
      afterClose: () => {
        dispatch(setLimitError(null));
      },
    });

    return () => {
      instance.destroy();
    };
  }, [limitError, modal, dispatch]);

  return null;
}

export default LimitExceedModal;
